
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Project"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectInterface"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"editPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"archived"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSelfArchived"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"topics"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"forksCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"starCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"visibility"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"openMergeRequestsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"openIssuesCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastActivityAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mergeRequestsAccessLevel"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stringValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"issuesAccessLevel"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stringValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"forkingAccessLevel"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stringValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"maxAccessLevel"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integerValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isCatalogResource"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exploreCatalogPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPublished"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gl_introduced"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"StringValue","value":"18.6.0","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"detailedStatus"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CiIcon"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"markedForDeletion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSelfDeletionInProgress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSelfDeletionScheduled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permanentDeletionDate"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":804}};
    doc.loc.source = {"body":"#import \"~/graphql_shared/fragments/ci_icon.fragment.graphql\"\n#import \"~/graphql_shared/fragments/project_interface.fragment.graphql\"\n\nfragment Project on Project {\n  ...ProjectInterface\n  editPath\n  archived\n  isSelfArchived\n  topics\n  forksCount\n  starCount\n  visibility\n  openMergeRequestsCount\n  openIssuesCount\n  descriptionHtml\n  createdAt\n  updatedAt\n  lastActivityAt\n  mergeRequestsAccessLevel {\n    stringValue\n  }\n  issuesAccessLevel {\n    stringValue\n  }\n  forkingAccessLevel {\n    stringValue\n  }\n  maxAccessLevel {\n    integerValue\n  }\n  isCatalogResource\n  exploreCatalogPath\n  isPublished @gl_introduced(version: \"18.6.0\")\n  pipeline {\n    id\n    detailedStatus {\n      ...CiIcon\n    }\n  }\n  markedForDeletion\n  isSelfDeletionInProgress\n  isSelfDeletionScheduled\n  permanentDeletionDate\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("~/graphql_shared/fragments/ci_icon.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql_shared/fragments/project_interface.fragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["Project"] = oneQuery(doc, "Project");
        
